<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :searchs="searchs"
      :form-fields="formFields" :permission="permission" :buttons="buttons" ref="table" @returnId="returnId"
      pageName="QianchuanScheduleTask" />

  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'QianchuanScheduleTask',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'groupId',
        placeholder: '账户分组',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiserGroup/getAll',
        selectData: [],
      }, {
        name: 'advertiserId',
        placeholder: '广告主',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
      }, {
        name: 'ruleName',
        placeholder: '任务名称',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '关闭',
        }, {
          key: 1,
          value: '开启',
        },]
      }, {
        name: 'roiType',
        placeholder: 'ROI类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '固定ROI',
        }, {
          key: 2,
          value: '按佣金率配置ROI',
        },]
      }, {
        name: 'repeatType',
        placeholder: '重复方式',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '每天',
        }, {
          key: 2,
          value: '工作日',
        }, {
          key: 3,
          value: '每周',
        }, {
          key: 4,
          value: '仅一次',
        }]
      }, {
        name: 'taskStartSetTimeFrom',
        placeholder: '任务开始设定时间 - 筛选开始',
        type: 'dateTime'
      },
      {
        name: 'taskStartSetTimeTo',
        placeholder: '任务开始设定时间 - 筛选结束',
        type: 'dateTime'
      },
      {
        name: 'taskLatestExecuteTimeFrom',
        placeholder: '任务最近执行时间 - 筛选开始',
        type: 'dateTime'
      },
      {
        name: 'taskLatestExecuteTimeTo',
        placeholder: '任务最近执行时间 - 筛选结束',
        type: 'dateTime'
      }, {
        name: 'taskEndSetTimeFrom',
        placeholder: '任务设定结束时间 - 筛选开始',
        type: 'dateTime'
      },
      {
        name: 'taskEndSetTimeTo',
        placeholder: '任务设定结束时间 - 筛选结束',
        type: 'dateTime'
      }],
      permission: {
        add: 'qianchuanScheduleTask:add',
        update: 'qianchuanScheduleTask:update',
        delete: 'qianchuanScheduleTask:delete',
        deleteBatch: 'qianchuanScheduleTask:deleteBatch'
      },
      url: {
        get: '/qianchuanScheduleTask/listByCondition',
        add: '/qianchuanScheduleTask/add',
        update: '/qianchuanScheduleTask/update',
        delete: '/qianchuanScheduleTask/delete',
        delete_batch: '/qianchuanScheduleTask/deleteBatch',
        status: '/qianchuanScheduleTask/status',
      },
      tableColumns: [
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
          field: 'advertiserName',  // 字段名
          label: '广告主',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'ruleName',  // 字段名
          label: '任务名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'planNameRule',  // 字段名
          label: '计划名称规则',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'dailyBudget',  // 字段名
          label: '日预算',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'roiType',  // 字段名
          label: 'ROI类型',  // 字段显示名称
          sort: false,
          show: {
            type: 'tag',
            tags: [
              {
                key: 1,
                value: '固定ROI',
                type: 'success'
              },
              {
                key: 2,
                value: '配置ROI',
                type: 'warning'
              }
            ]
          },
        }, {
          field: 'fixedRoi',  // 字段名
          label: '固定ROI值',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'suggestRoiThreshold',
          label: '建议ROI阈值',
          sort: false,
          show: true,
        }, {
          field: 'startTime',  // 字段名
          label: '开始时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'repeatType',
          label: '重复方式',
          sort: false,
          show: {
            type: 'tag',
            tags: [
              { key: 1, value: '每天', type: 'success' },
              { key: 2, value: '工作日', type: 'info' },
              { key: 3, value: '每周', type: 'warning' },
              { key: 4, value: '一次', type: 'danger' }
            ]
          },
        }, {
          field: 'status',
          label: '状态',
          sort: false,
          status: true,
          show: {
            type: 'tag',
            tags: [
              { key: 0, value: '停用', type: 'danger' },
              { key: 1, value: '开启', type: 'success' }
            ]
          },
        },
        // {
        //   field: 'createdBy',  // 字段名
        //   label: '创建人',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        // }, {
        //   field: 'updatedBy',  // 字段名
        //   label: '更新人',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        // },
        {
          field: 'lastExecuteTime',  // 字段名
          label: '最近执行时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'endTime',  // 字段名
          label: '结束时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        labelWidth: '100px',
        addGuide: {
          title: '单品智能定时投放任务说明',
          summary: '这张表单用于给单个商品建立自动投放规则。保存后，系统会在你设定的时间、账户和 ROI 逻辑下自动创建投放计划。',
          icon: 'el-icon-time',
          points: [
            '适合固定商品、固定账户、固定投放节奏的自动化场景。',
            '开始时间至少要晚于当前时间 10 分钟，避免刚保存就立即触发。',
            '如果你不确定 ROI 怎么选，先看下面的 <strong>ROI类型说明</strong> 再保存。'
          ]
        },
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },

        {
          field: 'ruleName',  // 字段名
          label: '任务名称',  // 字段显示名称
          type: 'input',
          placeholder: '请输入任务名称',
          rules: [
            { required: true, message: '任务名称不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'accountIds',
          label: '账户：',
          type: 'select',
          placeholder: '请选择账户',
          rules: [{ required: true, message: '请选择账户', trigger: 'blur' }],
          selectUrl: '/qianchuanScheduleTask/getAbleInvestAccount',
          multiple: true,
          isSelectAll: true,
          selectData: [],
          add: true,
          update: false,
          isGet: true,
          filterable: true,
        }
          // , {
          //   field: 'planNameRule',  // 字段名
          //   label: '计划名称',  // 字段显示名称
          //   type: 'input',
          //   placeholder: '请输入计划名称',
          //   rules: [
          //     { required: true, message: '计划名称不能为空', trigger: 'blur' }
          //   ],
          //   add: true,
          //   update: true,
          // }
          , {
          field: 'dailyBudget',  // 字段名
          label: '日预算',  // 字段显示名称
          type: 'input',
          placeholder: '请输入日预算',
          rules: [
            { required: true, message: '日预算不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        },
        {
          field: 'roiType',  // 字段名
          label: 'ROI类型',  // 字段显示名称
          type: 'select',
          placeholder: '请选择ROI类型',
          rules: [
            { required: true, message: '请选择ROI类型', trigger: 'blur' }
          ],
          selectData: [{
            id: 1,
            name: '固定ROI'
          }, {
            id: 2,
            name: '配置ROI'
          }],
          guide: {
            title: '两种 ROI 模式区别',
            summary: '先决定“所有投放统一用一个 ROI”，还是“按佣金率自动匹配 ROI”。',
            icon: 'el-icon-data-line',
            points: [
              '<strong>固定ROI</strong>：统一使用你手填的固定值，适合快速起量、先验证任务链路。',
              '<strong>配置ROI</strong>：不直接填单一 ROI，而是去读取 <strong>单品保本ROI配置</strong> 页面里的佣金率映射规则，自动匹配更适合当前商品的 ROI。',
              '如果启用了建议ROI阈值或保本ROI校验，系统还会在正式投放前再做一层拦截。'
            ]
          },
          add: true,
          update: true,
        },
        {
          field: 'fixedRoi',  // 字段名
          label: '固定ROI',  // 字段显示名称
          type: 'input',
          placeholder: '请输入固定ROI',
          rules: [
            { required: false, message: '请输入固定ROI', trigger: 'blur' }
          ],
          add: true,
          update: true,
          isChange: true
        },
        {
          field: 'suggestRoiThreshold',  // 字段名
          label: '建议ROI阈值',  // 字段显示名称
          type: 'number',
          min: 0,
          placeholder: '请输入建议ROI阈值',
          tip: '提示：若查询到的建议ROI &lt; 该阈值，则跳过本次投放，留空则按原有逻辑执行',
          add: true,
          update: true,
          isCheck: true,
          checkField: 'enableSuggestRoiThreshold'
        },
        {
          field: 'enableBreakEvenRoiCheck',
          label2: '启用保本ROI校验 (保本ROI < 建议 ROI 才允许投放)',
          type: 'checkbox',
          tip: '提示: 勾选后,必须满足「保本ROI <建议ROI」才进入后续判断;不满足则直接跳过投放',
          default: false,
          add: true,
          labelWidth: '15px',
          update: true,
          isShowByOtherField: 'enableSuggestRoiThreshold'
        },
        {
          field: 'startTime',  // 字段名
          label: '开始时间',  // 字段显示名称
          type: 'dateTime',
          placeholder: '请选择开始时间',
          rules: [
            { required: true, message: '开始时间不能为空', trigger: 'blur' },
            {
              required: false,
              validator: (rule, value, callback) => {

                console.log(rule, value, callback)
                if (!rule.required) {
                  callback()
                  return

                }
                // 获取当前时间
                const now = new Date();
                // 计算当前时间加10分钟的时间点
                const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);

                // 将选择的时间转换为Date对象
                const selectedTime = new Date(value);

                // console.log(selectedTime, tenMinutesLater, selectedTime < tenMinutesLater)
                // 检查选择的时间是否早于10分钟后
                if (selectedTime < tenMinutesLater) {
                  callback(new Error(`开始时间应大于当前时间的10分钟`));
                } else {
                  callback();
                }
              },
              message: '开始时间应大于当前时间的10分钟',
              trigger: ['blur', 'change']// 时间选择变化时触发验证
            }
          ],
          add: true,
          update: true,
        }, {
          field: 'repeatType',  // 字段名
          label: '执行频率',  // 字段显示名称
          type: 'select',
          placeholder: '执行频率',
          rules: [
            { required: true, message: '执行频率不能为空', trigger: 'blur' }
          ],
          selectData: [{
            id: 1,
            name: '每天'
          }, {
            id: 2,
            name: '工作日'
          }, {
            id: 3,
            name: '每周'
          }, {
            id: 4,
            name: '一次'
          }],
          add: true,
          update: true,
        },
        {
          field: 'endTime',  // 字段名
          label: '结束时间',  // 字段显示名称
          type: 'dateTime',
          placeholder: '请选择结束时间',
          rules: [
            { required: false, message: '结束时间不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        },

        ]
      },
      operate: [{
        icon: 'el-icon-tickets',
        type: 'text',
        text: '日志',
        handle: (row) => {
          console.log(row)

          this.$router.push({
            path: '/qdd/admin/QianchuanTaskLog.html',
            query: { id: row.advertiserId, getLog: true }
          })
        }
      }],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量修改任务状态',
        notNeedPermission: true,
        click: () => {
          console.log(this.selectIds, 11111111111111111111)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改视频状态的任务')
            return
          }
          request.post({
            url: '/qianchuanScheduleTask/batch/status',
            data: { ids: this.selectIds.join(",") },
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改视频状态成功");
                this.$refs.table.getData()
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }],

    }
  },
  methods: {
    // 新增：接收选中的ID
    returnId(data) {
      this.selectIds = data;
      console.log('选中的ID:', this.selectIds)
    }
  }
}
</script>

<style scoped></style>
